import React, { useEffect, useState } from "react";

// Styles
import "./App.css";
import "static/scss/main.scss";

// Router
import RootRouter from "router/rootRouter";

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { GC } from "services/config/gamecentreService";
import { storage } from "services/config/storage";

export const NEW_DATA_EVENT = "NEW_DATA_EVENT";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

function App() {
  const [gameDetails, setGameDetails] = useState(null);
  const gameInIframe = window.location !== window.parent.location;

  const syncData = () => {
    const getGameDetails = storage.get.gameDetails();
    setGameDetails(getGameDetails);
  };

  useEffect(() => {
    (async () => {
      if (!gameInIframe) {
        // Not calling gamecenter apis if not loaded in it.
        return;
      }
      // Focus on window to capture key press events when running on iframe
      if (document.hasFocus() === false) {
        window.focus();
      }
      // Send mount/load event to assessment centre to get token and gameplayId (linkId)
      GC.sendGameLoadMessage();
    })();
    window.addEventListener("message", GC.messageEventHandler);
    window.addEventListener(NEW_DATA_EVENT, syncData);
    return () => {
      window.addEventListener("message", GC.messageEventHandler);
      window.removeEventListener(NEW_DATA_EVENT, syncData);
    };
  }, []);

  return (
    <Sentry.ErrorBoundary
      onError={(err) => console.log(err)}
      fallback={<p>An error has occurred</p>}
    >
      <div className="App">
        <RootRouter />
      </div>
    </Sentry.ErrorBoundary>
  );
}

export default App;
